import { useContext, useRef } from 'react'

import { TextField } from '@material-ui/core'

import ContentModalContext from '../../ContentModalProvider/Context'
import { FIELD_NAMES, LABELS } from '../../components/constants'

const fieldName = FIELD_NAMES.ALTTEXT
const label = LABELS.ALTTEXT
const id = 'content-item-alt-text-required-message'

const AltText = () => {
  const { item, onUpdateField } = useContext(ContentModalContext)

  const touchedRef = useRef(false)
  const value = item[fieldName]

  return (
    <TextField
      id={FIELD_NAMES.ALTTEXT}
      fullWidth
      variant="outlined"
      label={label}
      placeholder={label}
      value={value}
      aria-describedby={id}
      helperText="Alt text is used by screen readers to describe images to users with visual impairments."
      onChange={(e) => {
        touchedRef.current = true
        onUpdateField(fieldName, e.target.value)
      }}
    />
  )
}

export default AltText
